import React, { useEffect, useState } from "react";
import axios from "axios";
import { X } from "lucide-react";
import { SERVER_URL } from "../config";

const NotificationPanel = ({ employeeId, onClose, refreshCount }) => {
  const [notifications, setNotifications] = useState([]);

  const fetchNotifications = async () => {
    if (!employeeId) return;

    try {
      const res = await axios.get(`${SERVER_URL}/notification_helper.php`, {
        params: {
          action: "getNotifications",
          employee_id: employeeId,
        },
      });

      if (res.data.status) {
        setNotifications(res.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const markAsRead = async (id, link) => {
    try {
      await axios.post(
        `${SERVER_URL}/notification_helper.php?action=markAsRead`,
        { notification_sl: id }
      );

      refreshCount();
      onClose();

      window.location.href = link;
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!employeeId) return;
    fetchNotifications();
  }, [employeeId]);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      
      {/* 🔥 BLUR BACKGROUND */}
      <div
        className="absolute inset-0 bg-black/30 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* 🔥 MODAL */}
      <div className="relative w-[90%] max-w-md bg-emerald-50 rounded-2xl shadow-2xl">
        
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="font-semibold text-emerald-700">Notifications</h2>

          <button
            onClick={onClose}
            className="p-1 rounded-lg hover:bg-emerald-100"
          >
            <X size={20} />
          </button>
        </div>

        {/* Notifications List */}
        <div className="max-h-[400px] overflow-y-auto">
          {notifications.length === 0 ? (
            <p className="p-6 text-sm text-gray-500 text-center">
              No notifications
            </p>
          ) : (
            notifications.map((n) => (
              <div
                key={n.sl}
                onClick={() => markAsRead(n.sl, n.link)}
                className={`p-4 border-b cursor-pointer hover:bg-emerald-100 transition ${
                  n.is_read === 0 ? "bg-blue-100" : ""
                }`}
              >
                <p className="text-sm">{n.message}</p>
                <p className="text-xs text-gray-400 mt-1">
                  {n.created_at}
                </p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationPanel;